// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__3BWP9","input":"TextInput_input__BC8cF"};